export default function isDateFilterEnabled(filter: { endDate?: string; startDate?: string }) {
  return Boolean(filter?.startDate) || Boolean(filter?.endDate);
}
